import { observable, computed, action } from 'mobx'
import { apis, request } from "@/utils/net"

const defaultInvoiceData = {
    client_info: {}, // 开票方（商户）信息
    buyer_info: {}, // 购方信息
    goods_info: [], // 商品（开票项目）信息
    invoice_info: {}, // 发票信息
}

class Store {
    // 缓存发票信息，以便在提交成功后重置数据
    _invoiceData = {}
    // 发票数据
    @observable.shallow invoiceData = { ...defaultInvoiceData }

    // 普通开票，获取开票方（商户）信息
    @action fetchMerchantInfo() {
        return request({
            url: apis.getMerchantInfo,
            unforeseen: () => { }
        }).then(res => {
            this._invoiceData = {
                ...defaultInvoiceData,
                client_info: {
                    name: res.name,
                    tax_code: res.tax_code,
                    phone: res.sell_phone,
                    bank_name: res.sell_bank_name,
                    bank_account: res.sell_bank_account,
                    address: res.sell_address
                },
                invoice_info: {
                    remark: res.remark,
                    payee: res.payee, // 收款人
                    reviewer: res.reviewer, // 复核人
                    drawer: res.drawer, // 开票人
                }
            }
            this.refreshInvoiceData()
            return res
        })
    }

    @action refreshInvoiceData() {
        this.invoiceData = { ...this._invoiceData }
    }

    /**
     * 开票
     */
    @action invoice(invoiceData, invoiceDataAdd) {
        return request({
            url: apis.addInvoice,
            method: 'post',
            data: {
                ...this._parseInvoiceData(invoiceData),
                ...invoiceDataAdd
            }
        })
    }

    /**
     * 转换成老接口(提交开票接口)的开票数据
     */
    _parseInvoiceData(invoiceData) {
        const { client_info, goods_info, invoice_info } = invoiceData

        return {
            // 销方信息
            seller_name: client_info.name,
            taxpayer_num: client_info.tax_code,
            seller_address: client_info.address,
            seller_tel: client_info.phone,
            seller_bank_name: client_info.bank_name,
            seller_bank_account: client_info.bank_account,

            // 开票项目
            goods_info: JSON.stringify(goods_info),

            // 发票信息
            amount: invoice_info.total_price_with_tax,
            extra: invoice_info.remark,
            payee: invoice_info.payee,
            reviewer: invoice_info.reviewer,
            invoicer: invoice_info.drawer
        }
    }

    @observable.shallow hotelList = []

    @action getShopList() {
        return request({
            url: apis.getShopList,
            method: "get",
            data: {
                page: 1,
                pageSize: 999
            }
        }).then(res => {
            // console.log(res.store_list)
            this.hotelList = res.store_list
        })
    }
}

export default new Store()
